import { useState } from 'react'
import classnames from 'classnames'

import { IProject } from './useProjectApi'
import WriteForm from './actions/sc/WriteForm'
import ReadForm from './actions/sc/ReadForm'

const ScProject = ({ project }: { project: IProject }) => {
  const [activeTab, setActiveTab] = useState<'read' | 'write'>('read')
  const [selectedAction, setSelectedAction] = useState<any>(null)

  const writeActions = project.abi?.filter((f: any) => f.stateMutability === 'nonpayable')
  const readActions = project.abi?.filter((f: any) => f.stateMutability === 'view')

  const actionsArray = activeTab === 'write' ? writeActions : readActions

  const handleChangeTab = (tab: 'read' | 'write') => {
    setActiveTab(tab)
    setSelectedAction(null)
  }

  return (
    <div className="flex max-h-[80vh] w-full flex-col justify-between gap-4 sm:flex-row ">
      <div className="flex w-full flex-col justify-start rounded-lg border border-main-blue/50 bg-white bg-opacity-5 pb-2 font-normal text-white sm:w-1/3">
        <div className="flex h-12 w-full flex-row items-center justify-start font-semibold">
          <span
            className={classnames(
              'flex h-full w-1/2 cursor-pointer flex-col items-center justify-center border-b-2 border-main-blue/25',
              {
                '!border-main-blue': activeTab === 'write',
              },
            )}
            onClick={() => handleChangeTab('write')}>
            Write
          </span>
          <span
            className={classnames(
              'flex h-full w-1/2 cursor-pointer flex-col items-center justify-center border-b-2 border-main-blue/25',
              {
                '!border-main-blue': activeTab === 'read',
              },
            )}
            onClick={() => handleChangeTab('read')}>
            Read
          </span>
        </div>
        <div className="flex w-full flex-col items-start justify-between gap-4 overflow-auto px-4 pt-4">
          {actionsArray?.map((action: any, index: number) => (
            <span
              key={index}
              className={classnames(
                'w-full cursor-pointer font-semibold text-white/50 hover:text-white hover:underline',
                {
                  '!text-white': selectedAction?.name === action?.name,
                },
              )}
              onClick={() => {
                setSelectedAction(action)
              }}>
              {action?.name}
            </span>
          ))}
        </div>
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-4 rounded-lg border border-main-blue/75 bg-white bg-opacity-5 p-4 text-white sm:w-2/3">
        {selectedAction && (
          <>
            <span className="mb-4 text-xl capitalize">{selectedAction.name}</span>
            <WriteForm selectedAction={selectedAction} project={project} />
            <ReadForm selectedAction={selectedAction} project={project} />
          </>
        )}
      </div>
    </div>
  )
}

export default ScProject
